module.exports = __webpack_public_path__ + "static/media/lightness.1dc792db.png";